import { TableColumn } from '@app/shared/components/data-table/data-table.component';
import {
  FormField,
  ActionButton,
} from '@shared/components/add-form/add-form.component';
import { FormFieldConfig } from '@shared/components/search-form/search-form.component';

// ============================================================================
// INTERFACES
// ============================================================================

export interface PaymentConfigItem {
  access_key: string;
  isDisable: boolean;
  method_name: string;
  partner_code: string;
  partner_name: string;
  secret_key: string;
  store_Id: string;
  test: boolean;
  createdDate?: string;
  updatedDate?: string;
  createdBy?: string;
  updatedBy?: string;
}

export interface PaymentConfigFormConfig {
  title: string;
  formFields: FormField[];
  headerActions: ActionButton[];
  listRoute: string;
}

// ============================================================================
// FORM FIELD OPTIONS
// ============================================================================

export const PAYMENT_METHOD_OPTIONS = [
  { label: 'payment_config.methods.momo', value: 'momo' },
  { label: 'payment_config.methods.vnpay', value: 'vnpay' },
  { label: 'payment_config.methods.paypal', value: 'paypal' },
  { label: 'payment_config.methods.stripe', value: 'stripe' },
  { label: 'payment_config.methods.bank_transfer', value: 'bank_transfer' },
];
